// extracted by mini-css-extract-plugin
export default {"main":"PaginationGroup_main__6+GFq"};